import { proxy, useSnapshot } from 'valtio';

type Ui = {
  selectedPersonId?: string;
};

export const $ui = proxy<Ui>({});

export const useUi = () => useSnapshot($ui);
